import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { PlayerName } from "../atoms/PlayerName";
import { Balance } from "../atoms/Balance";
import { CircleButton } from "../atoms/CircleButton";

const PlayerNameBox = styled.span`
  background-color: #ffff;
  box-shadow: 0 0 0.35rem #000a;
  border: 1px solid black;
  border-radius: 5px;
  padding: 0.25rem;
  min-height: 4rem;
  min-width: 12rem;
  display: flex;
  flex-direction: column;
  /* transform: scale(1.1); */
`;

const ButtonContainer = styled.span`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
`;

export const PlayerBadge = ({ name, balance, handleAddExpense }) => {
  return (
    <PlayerNameBox>
      <PlayerName>{name}</PlayerName>
      <Balance amount={balance} />
      <ButtonContainer>
        <CircleButton handleClick={handleAddExpense}>+</CircleButton>
      </ButtonContainer>
    </PlayerNameBox>
  );
};

PlayerBadge.propTypes = {
  name: PropTypes.string.isRequired,
  balance: PropTypes.number.isRequired,
};
